<script setup>

    import { computed } from 'vue';

    const props = defineProps({
        note: {
            type: Object,
            required: true,
        }
    })

    const createdAtDate = computed(() => {
        if (!props.note.created_at) {
            return '—';
        }
        const date = new Date(props.note.created_at * 1000);
        return date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    });

    const updatedAtDate = computed(() => {
        if (!props.note.updated_at) {
            return '—';
        }
        const date = new Date(props.note.updated_at * 1000);
        return date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    });

    const noteHtml = computed(() => {
        if (!props.note.notes) {
            return '';
        }
        return props.note.notes.replace(/\n/g, '<br>');
    })

    const feedbackColor = computed(() => {

        if (!props.note.notes) {
            return 'text-lifeworx-blue-800';
        }

        if (props.note.notes.includes('<i>Rating:</i> <b style=\'color: #33a027\'>')) {
            return 'text-lifeworx-green-500';
        }
        if (props.note.notes.includes('<i>Rating:</i> <b style=\'color: #eab308\'>')) {
            return 'text-lifeworx-yellow-600';
        }
        if (props.note.notes.includes('<i>Rating:</i> <b style=\'color: #cc291d\'>')) {
            return 'text-lifeworx-red-500';
        }

        return 'text-lifeworx-blue-800';
    })


</script>

<template>
    <div v-if="note.creator">
        <div class="flex items-center gap-1 pb-1">
            <span class="text-xs font-bold text-lifeworx-blue-800">
                {{ note.creator.first_name ?? 'Unknown' }} {{ note.creator.last_name ?? '' }}
            </span>
            <span class="text-xs text-lifeworx-blue-800">
                on {{ createdAtDate }}
            </span>
        </div>
        <div
            class="pl-2 pb-4 text-sm text-lifeworx-blue-800"
            v-html="noteHtml"
        />
    </div>
    <div v-else>
        <div class="flex items-center gap-1 pb-1">
            <span :class="[ 'text-xs font-bold', feedbackColor ]">
                Feedback
            </span>
            <span class="text-xs text-lifeworx-blue-800">
                updated at {{ updatedAtDate }}
            </span>
        </div>
        <div
            class="pl-2 pb-4 text-sm"
            v-html="noteHtml"
        />
    </div>
</template>
